import React from 'react'
import { withStyles } from '@material-ui/core/styles';
import * as http from '../util/http';
import CommentIcon from '@material-ui/icons/Comment'
import FileUpload from '@material-ui/icons/FileUpload'; 
import IconButton from '@material-ui/core/IconButton'
import DeleteIcon from '@material-ui/icons/Delete'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import DialogTitle from '@material-ui/core/DialogTitle'
import TextField  from '@material-ui/core/TextField'
import Tooltip from '@material-ui/core/Tooltip'
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar'
import store from '../store'
import {HANDLE_OPEN} from '../uis/tip/reduces'
import {getUserInfo} from '../util/http'
import ossUpload from '../util/ossUpload'

const styles = theme => ({
        root: {
        width: 35,
        height: 35,
        overflow: 'hidden',
        position: 'fixed',
        right: 0,
        top: '40%',
        marginTop: -25,
        zIndex: 999999,
        minHeight:30,
        backgroundColor: '#828282',
        borderRadius: '5px 0 0 5px'
    },
    button: {
        width: 35,
        height: 35,
        overflow: 'hidden',
        position: 'fixed',
        right: 0,
        top: '40%',
        marginTop: -25,
        zIndex: 999999,
        minHeight:30
    },
    dialogContent: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center'
    },
    textField: {
        width: 300
    },
    input: {
        display: 'none',
    },
    imgContaier: {
        margin: theme.spacing.unit * 3,
        textAlign: 'center'
    },
    gridList: {
        width: 500
    },
    label: {
        display: 'inline-block',
        width: 300,
        textAlign: 'left'
    }
})
const uploadImg = "uploadImg"
class Feedback extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            open: false,
            title: '',
            content: '',
            pictureUrls: []  
        }
        this.deletePicture =  this.deletePicture.bind(this)
    }
    handleOpen = () => {
        this.setState({ open: true })
    }
    handleClose = () => {
        this.setState({ open: false })
    }
    handleChange = key => e => {
        this.setState({
            [key]: e.target.value
        })
    }
    uploadImgFile(pictureUrls) {
        if (pictureUrls.length >= 5) {
            store.dispatch({type: HANDLE_OPEN,variant: 'error',message: '上传图片不能超过5张',time:1500})
            return Promise.resolve()
        }
        const userInfo = getUserInfo()
        return ossUpload(`${userInfo.user.name}`,uploadImg)
            .then((data) => {
                if (!(data instanceof Array)) {
                    data = [data]
                }
                data.forEach(item => {
                    pictureUrls.push(item)
                    // this.setState({pictureUrls})
                })
                this.setState((prevState,props) => ({pictureUrls}))
            })
    }
    deletePicture(index,pictureUrls){
        this.setState({pictureUrls: pictureUrls.filter((item, ii)=>ii !== index)})
    }
    
    sendFeedback() {
        const {title,content,pictureUrls} = this.state
        const fileUrl = pictureUrls.map((item,index) => {
            return item.url
        }).join(',')
        const formData = {
            title,
            content,
            fileUrl
        }
        return http.post(`/feedback/add`,formData)
            .then(() => {        
                store.dispatch({type: HANDLE_OPEN,variant: 'success',message: '反馈已成功提交！',time:2000})  
                this.handleClose()
                this.setState({title: ''})
                this.setState({content: ''})
                this.setState({pictureUrls: []})
            })
}
    render() {
        const {open,title,content,pictureUrls} = this.state
        const {classes} = this.props
        return (
            <div>
                <div className={classes.root}>
                    <Tooltip id="feedback" title={<div>碰到疑问时，可点击此处反馈问题</div>} placement="left">
                        <IconButton className={classes.button} onClick={this.handleOpen}>
                            <CommentIcon style={{color: '#fff'}} />
                        </IconButton>
                    </Tooltip>
                </div>
                <Dialog
                    open={open}
                    onClose={this.handleClose}
                    fullWidth
                >
                    <DialogTitle>请填写反馈内容</DialogTitle>
                    <DialogContent className={classes.dialogContent}>
                        <TextField 
                            label="标题"
                            placeholder="标题(非必填)"
                            className={classes.textField}
                            margin="normal"
                            value={title}
                            onChange={this.handleChange('title')}
                        />
                        <TextField 
                            label="内容"
                            placeholder="内容(非必填)"
                            className={classes.textField}
                            margin="normal"
                            multiline
                            value={content}
                            onChange={this.handleChange('content')}
                        />
                        <div className={classes.imgContaier}>
                            <input
                                accept="image/*"
                                className={classes.input}
                                id="uploadImg"
                                multiple
                                type="file"
                                onChange={() => this.uploadImgFile(pictureUrls)}
                            />
                            <label htmlFor="flat-button-file" className={classes.label}>
                                <Button component="span" color="primary" onClick={()=>document.getElementById(uploadImg).click()}>
                                    {pictureUrls.length === 0 ? '上传截图' : `已选择${pictureUrls.length}张截图`}
                                    <FileUpload />
                                </Button>
                            </label>
                            <GridList className={classes.gridList}>
                                {pictureUrls.map((tile, index) => (
                                    <GridListTile
                                        key={index}
                                    >
                                        <img src={tile.url} role="presentation" alt="图片" />
                                        <GridListTileBar
                                            title={tile.filename}
                                            actionIcon={
                                                <IconButton onClick={() => this.deletePicture(index,pictureUrls)}>
                                                    <DeleteIcon />
                                                </IconButton>
                                            }
                                        />
                                    </GridListTile>
                                ))}
                            </GridList>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="outlined" onClick={this.handleClose}>取消</Button>
                        <Button variant="outlined" color="primary" onClick={() => this.sendFeedback()}>确定</Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}

export default withStyles(styles)(Feedback)


// WEBPACK FOOTER //
// ./src/uis/feedback.js